import React from 'react';
import Select from "react-select";
import styles from "./MultiSelectDropdown.module.css";
import {getSelectorStyles} from "./selectorStyles";
import classnames from "classnames";
import {SelectOption} from "../select/SelectDropdown";

interface Props<PROPERTY> {
    title: string;
    titleAccessory?: React.ReactNode;
    isRequired?: boolean;
    value?: PROPERTY[];
    handleChange: (v: PROPERTY[]) => any;
    options: SelectOption<PROPERTY>[];
    errorMessage?: string;
    disabled?: boolean;
    isEqual: (a: PROPERTY, b: PROPERTY) => boolean;
}


export const MultiSelectDropdown = <PROPERTY, >({
                                                    title,
                                                    titleAccessory,
                                                    isRequired,
                                                    value,
                                                    handleChange,
                                                    options,
                                                    errorMessage,
                                                    disabled = false,
                                                    isEqual
                                                }: Props<PROPERTY>) => {

    const getSelectOptionsByValue = () => {
        if (Array.isArray(value)) {
            return options.filter(o =>
                value.some(v => v !== undefined && o.value !== undefined && isEqual(v, o.value))
            );
        } else {
            return options.find(o => value !== undefined && o.value !== undefined && isEqual(o.value, value as PROPERTY)) || null;
        }
    };

    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
            <span className={classnames(styles.title, disabled && styles.disabledTitle)}>{title}</span>
            {(isRequired && !disabled) && <span className={styles.asterisk}>*</span>}
            {titleAccessory}
        </div>
        <Select
            isMulti={true}
            isDisabled={disabled}
            value={getSelectOptionsByValue()}
            onChange={selected => {
                handleChange((selected).map(s => s.value));
            }}
            options={options}
            styles={getSelectorStyles(errorMessage)}
        />
        <div style={{visibility: errorMessage ? "visible" : "hidden"}} className={styles.errorWrapper}>
            <img src={"/alertIcon.svg"} alt={"alert icon"}/>
            <span className={styles.errorMessage}>{errorMessage}</span>
        </div>
    </div>
}
